import Table from "./Table";

export default Table;



// WEBPACK FOOTER //
// ./src/components/RevvTable/index.js